import { WrapSameLineIcon } from 'canoe';
import React from 'react';

import { ValueToggle } from '@candu-ai/craft/ui';

interface Props {
  flexWrap?: string;
  setCss: (css: Record<string, any>) => void;
}

export const FlexNoWrap = ({ flexWrap, setCss }: Props) => {
  return (
    <ValueToggle
      toggleGroup="flex-wrap"
      id="no-wrap"
      data-cy="toolbox-flex-nowrap"
      onClick={() =>
        setCss({
          flexWrap: null,
        })
      }
      isActive={flexWrap === 'no-wrap'}
      icon={WrapSameLineIcon}
      tooltip="No Wrap"
      color="light"
    />
  );
};
